export const configCloudinaryWidget = (
	setCloudinaryUploadWidget,
	handleSuccessfulFileUpload
) => {
	$.getScript('https://upload-widget.cloudinary.com/global/all.js').then(
		() => {
			const tempWidget = cloudinary.createUploadWidget(
				{
					cloudName: 'sponsor-circle',
					uploadPreset: 'pv9mlmap',
					multiple: false,
					sources: [
						'local',
						'instagram',
						'google_drive',
						'facebook',
						'shutterstock',
						'gettyimages',
						'istock',
						'unsplash',
					],
				},
				(error, result) => {
					// This should rarely be the case, but if the cap on gallery files is hit, then immediately close the widget
					if (!error && result && result.event === 'success') {
						handleSuccessfulFileUpload(result);
					} else if (error) {
						console.error(error);
					}
				}
			);

			setCloudinaryUploadWidget(tempWidget);
		}
	);
};
